module.exports = __webpack_public_path__ + "static/media/soop_inner.11befeec.svg";